import { useEffect, useState } from 'react';

import { useCommonAppServices } from '../services/ContextProviders';
import { useObservableAndState } from './useObservableAndState';

export function usePromotionHistoryCount() {
  const [historyCount, setHistoryCount] = useState<number | null>(null);
  const { apiClient, accountService } = useCommonAppServices();
  const { providerId } = useObservableAndState(accountService.getSelectedProviderData$());

  useEffect(() => {
    if (!apiClient || !providerId) {
      return;
    }

    apiClient.deliveryCampaignProvider
      .getPromotionsHistory({ provider_id: providerId, limit: 1, offset: 0 })
      .then((response) => {
        setHistoryCount(response.result_count || 0);
      })
      .catch(() => {
        setHistoryCount(0);
      });
  }, [apiClient, providerId]);

  return historyCount;
}
